/**
 * Import Style
 */
import 'swiper/css/pagination'
import 'swiper/css/thumbs'

/**
 * Import Features
 */
import {sliderHomeHero} from "./features/sliderHomeHero";
import {sliderHomeTestimony} from "./features/sliderHomeTestimony";
import {sliderTestimonyList} from "./features/sliderTestimonyList";
import {sliderGallery} from "./features/sliderGallery";
import {sliderGifts} from "./features/sliderGifts";
import { sliderOtherTestimony } from './features/sliderOtherTestimony';
import { sliderHomeAvis } from './features/sliderHomeAvis';

/**
 * Import Utils
 */
import {ui} from "./utils/ui";

export default () => {
    // Slider Homepage Hero
    if (ui.homeHero) sliderHomeHero(ui.homeHero);

    // Slider Homepage Testimony Section on Mobile size
    if (ui.homeTestimony) sliderHomeTestimony(ui.homeTestimony);

    // Slider Testimony List
    if (ui.testimonyList) sliderTestimonyList(ui.testimonyList);

    // Slider Gallery
    if (ui.gallery.large && ui.gallery.small) sliderGallery(ui.gallery.large, ui.gallery.small);

    // Slider Gifts
    if (ui.gifts) sliderGifts(ui.gifts);

    // Slider Other Testimony
    if (ui.otherTestimony) sliderOtherTestimony(ui.otherTestimony);

    // Slider Avis
    if (ui.avis) sliderHomeAvis(ui.avis);
}
